module.exports = {
  defaultTitle: 'Vilhelm Stokstad',
  logo: 'favicon/favicon-512.svg',
  author: 'Vilhelm Stokstad',
  url: 'https://vilhelmstokstad.com',
  legalName: 'Vilhelm Stokstad',
  defaultDescription: 'I’m Vilhelm and I’m a game developer',
  socialLinks:{
  twitter: 'https://www.twitter.com/vstokstad',
  github: 'https://github.com/vstokstad',
  linkedin: 'https://www.linkedin.com/in/vilhelmstokstad/',
  instagram: 'https://instagram.com/vstokstad'
  },
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
  facebook: 'appID',
  twitter: '@vstokstad',
    github: 'vstokstad',
  },
  address: {
  city: 'Stockholm',
  region: 'Nacka',
  country: 'Sweden',
  zipCode: '13135',
  },
  contact: {
    email: 'v.stokstad@gmail.com',
    phone: '+46735019539',
  },
  foundingDate: '2020',
  googleAnalyticsID: 'UA-37134072-1'
};